import { ref } from 'vue'
import useValidate from '@/shared/lib/validate'

export const useModel = () => {
  const { required } = useValidate()

  const open = ref(false)
  const statusType = ref('DRAFT')
  const comment = ref('')
  const file = ref<File | null>(null)

  /* Правила валидации */
  const rules = {
    comment: [(value: string) => required(value)],
  }

  /**
   * Очистить данные формы
   */
  const clearData = () => {
    open.value = false
    statusType.value = 'DRAFT'
    comment.value = ''
    file.value = null
  }

  return {
    open,
    statusType,
    comment,
    file,
    rules,

    clearData,
  }
}
